export default {
  // ConfirmModal 组件
  confirmModal: {
    title: '验证您的企业',
    description: '为了加快您的活动审核，请提供工作邮箱地址来验证您的企业。',
    workEmailLabel: '工作邮箱',
    emailPlaceholder: '请输入您的邮箱',
    emailValidationMessage: '请输入企业邮箱地址',
    emailError: '请输入企业邮箱地址',
    noWorkEmailText: '没有工作邮箱？',
    clickHere: '点击这里',
    sendEmailText: '向我们发送任何企业或合作伙伴文件作为代理。您也可以直接通过以下方式联系我们',
    back: '返回',
    continue: '继续',
    emailSentTitle: '验证您的企业',
    emailSentDescription: '我们已向',
    emailSentCodeDescription: '发送了一封包含6位数字验证码的邮件，该验证码将在10分钟后过期。请在下方输入验证码。',
    resendIn: '重新发送',
    resendText: '没有收到邮件。',
    resend: '重新发送',
    contactUs: '如果您需要任何帮助，请随时',
    contactUsLink: '联系我们。'
  },

  // AdsGuideModal 组件
  adsGuideModal: {
    // 通用
    title: 'AhaCreator 使用指南',
    description: '快速了解使用要点和小技巧，帮助你在 AhaCreator 上事半功倍',
    close: '关闭',
    next: '下一步',
    previous: '返回',
    skip: '跳过',
    finish: '完成',
    
    // Step1
    step1: {
      title: '欢迎来到营销指南',
      description: '一起开启你的红人营销旅程',
      startButton: '开始使用',
      tips: '小帖士',
      influencerContact:
        '部分达人可能会联系你确认与 AhaCreator 的合作关系。请如实回复并完成验证。为保障权益，尽量避免平台外沟通，以免缺少平台监管。',
      promptlyApproving: '及时审批申请',
      promptlyApprovingDescription:
        '有助于锁定达人的排期并提升合作成功率；反馈拖延会增加达人失联的风险。',
      headFollowUp:
        'AhaCreator 会主动跟进达人，将行业普遍 30–40% 的逾期率降低至约 20%。不过我们仍然',
      recommendExtraInfluencers: '建议多选择一些达人',
      recommendExtraInfluencersDescription:
        '以确保达到营销目标；未交付部分将 100% 退款。'
    },
    
    // Step2
    step2: {
      title: '选择社交媒体',
      description: '选择你希望的红人营销社交媒体',
      platform: '社交媒体',
      selectPlatform: '选择社交媒体',
      aiAgentsPolicy:
        'AhaCreator Agent对达人执行严格规范。如发现违规范行为，请使用“举报”功能反馈。',
      tips: '贴士'
    },
    
    // Step3
    step3: {
      title: '设置预算',
      description: '定义你的营销预算',
      budget: '预算',
      setBudget: '设置预算'
    },
    
    // Step5
    step5: {
      title: '目标受众',
      description: '定义你的目标受众',
      audience: '受众画像',
      demographics: '人群特征',
      interests: '兴趣',
      location: '地区',
      noSampleShipment: '无需寄样',
      withSampleShipment: '需要寄样',
      dedicatedVideo: '全片',
      integratedVideo: '插片',
      tips: '贴士'
    },
    
    // Step6
    step6: {
      title: '检查并发布',
      description: '发布前请再次核对活动设置',
      review: '检查',
      launch: '发布营销计划',
      settings: '计划设置',
      keyRequirements: '关键要求',
      requirementsDescription: '根据以下要求向达人提供反馈，以提升转化效率'
    },
    
    // PlatformsTab
    platformsTab: {
      facebook: 'Facebook',
      instagram: 'Instagram',
      google: 'Google Ads',
      tiktok: 'TikTok',
      youtube: 'YouTube',
      twitter: 'X（Twitter）',
      linkedin: 'LinkedIn'
    },
    
    // 营销策略
    marketing: {
      influencer: '达人营销',
      affiliate: '联盟分销'
    },
    
    // 步骤项目
    items: {
      aiAgents: 'AI 代理接下来会做什么',
      platformGuarantee: '平台保障',
      noResultsNoPayment: '无效果不付费',
      deliveryTimelines: '交付时效',
      contentRequirements: 'AhaCreator 的内容要求'
    },
    
    // 配置相关
    config: {
      // Step5 配置
      step5: {
        promptFeedback: '及时反馈',
        promptFeedbackDescription: '能显著提升达人履约与投放效果'
      },
      
      // Step6 配置
      step6: {
        youtube: {
          cta: '行动引导（CTA）',
          ctaDescription: '将 CTA 放在视频最具吸引力的节点，最大化抓取兴趣',
          description: '描述区',
          descriptionText:
            '在描述开头使用强力 CTA，并确保 CTA 与链接在折叠状态下也清晰可见。',
          videoLength: '视频时长',
          videoLengthText: '建议整体视频时长不少于 5 分钟',
          headProvidedLink: 'AhaCreator 提供的链接',
          headProvidedLinkText:
            '请务必使用 AhaCreator 提供的推广链接，勿使用官网链接或跳转链接。',
          platformRequirements: '查看平台要求以获取完整规范'
        },
        tiktok: {
          endingCta: '结尾 CTA',
          endingCtaDescription:
            '在视频结尾通过口播和字幕进行 CTA，例如：“更多信息请点开个人主页的链接！”',
          caption: '文案',
          captionDescription:
            '使用简洁有力的文案与明确 CTA，例如：“现在就点开主页链接查看！🌟”',
          linkInBio: '主页链接',
          linkInBioDescription:
            '将链接放在个人主页顶部。如使用 Linktree，请将推广链接置于 Linktree 之上，或作为 Linktree 的第一个链接，确保易于访问。',
          headProvidedLink: 'AhaCreator 提供的链接',
          headProvidedLinkText:
            '请务必使用 AhaCreator 提供的推广链接，勿使用官网链接或跳转链接。（除非与广告主协商）',
          platformRequirements: '查看平台要求以获取完整规范'
        },
        twitter: {
          endingCta: '结尾 CTA',
          endingCtaDescription:
            '若发布视频，请在结尾通过口播与字幕提示，例如：“更多信息请查看推文中的链接！”',
          caption: '文案',
          captionDescription:
            '在文案中加入强力 CTA，例如：“了解更多：{link}🌟”',
          headProvidedLink: 'AhaCreator 提供的链接',
          headProvidedLinkText:
            '请务必使用 AhaCreator 提供的推广链接，勿使用官网链接或跳转链接。',
          platformRequirements: '查看平台要求以获取完整规范'
        },
        instagram: {
          endingCta: '结尾 CTA',
          endingCtaDescription:
            '如发布 Reels，请清晰提示“查看主页链接！”，具体以你可用的功能为准。',
          caption: '文案',
          captionDescription:
            '使用简洁有力的文案与明确 CTA，例如：“现在就去主页点击链接！🌟”',
          linkInBio: '主页链接',
          linkInBioDescription:
            '将链接放在个人主页顶部。如使用 Linktree，请将推广链接置于 Linktree 之上，或作为 Linktree 的第一个链接，确保易于访问。',
          headProvidedLink: 'AhaCreator 提供的链接',
          headProvidedLinkText:
            '请务必使用 AhaCreator 提供的推广链接，勿使用官网链接或跳转链接。',
          platformRequirements: '查看平台要求以获取完整规范'
        },
        linkedin: {
          endingCta: '结尾 CTA',
          endingCtaDescription:
            '若发布含视频的帖子，请在视频中加入清晰的口播或文字 CTA，例如：“更多信息请查看本帖中的链接。”',
          caption: '文案',
          captionDescription:
            '在文案中加入强力 CTA，例如：“了解更多：{link}🌟”',
          headProvidedLink: 'AhaCreator 提供的链接',
          headProvidedLinkText:
            '请务必使用 AhaCreator 提供的推广链接，勿使用官网链接或跳转链接。',
          platformRequirements: '查看平台要求以获取完整规范'
        }
      },
      
      // 标题配置
      titles: {
        aiAgents: 'AI 代理接下来会做什么',
        collaborateConfidently: '有结果保障，更安心地展开合作',
        noResultsNoPayment: '无效果不付费',
        deliveryRequirements: 'AI 代理对达人交付的要求'
      }
    }
  },
  
  // AgentModal 组件
  agentModal: {
    header: {
      setupHeadDna: '设置 AhaCreator 的品牌 DNA',
      skip: '跳过',
      brandImageSetup: '品牌形象设置',
      toneOfVoice: '品牌语气',
      brandIdentification: '品牌识别'
    },
    dnaSuccess: {
      congratulations: '恭喜！',
      completionMessage: '你已成功完成新手引导。',
      continue: '继续'
    },
    end: {
      congratulations: '恭喜！你的品牌 DNA 已准备就绪。',
      description:
        '我已迫不及待为你产出更贴合品牌的策略与内容。一起创造更好的增长吧！',
      startCampaign: '发起高效活动',
      dailyTasks: '处理我的日常任务'
    },
    linkInput: {
      title: '塑造你的 AhaCreator 品牌 DNA',
      description: '输入你的网站或社媒链接',
      platforms: '（LinkedIn、X、TikTok、Instagram）',
      startNow: '立即开始',
      validationError: '请输入有效的网站或社媒链接',
      sessionIdError: '获取会话 ID 失败。',
      newConversation: '新对话'
    },
    operationComponent: {
      goodResponse: '反馈良好',
      needImprovement: '需要改进'
    },
    restComponent: {
      message: '你回复后，AhaCreator 会继续为你推进。'
    },
    thinking: {
      message: '思考中…'
    },
    toolsComponent: {
      campaignSettings: '生成营销计划设置供确认',
      audienceOptimization: '基于营销计划信息生成最优受众，以驱动'
    }
  },

  // AhaCheck 组件
  ahaCheck: {
    recommended: '推荐'
  },
  
  // AiAgent 组件
  aiAgent: {
    head: 'AhaCreator',
    hide: '收起',
    showMore: '展开更多'
  },
  
  // ApproveInfluencersEffortlesslyModal 组件
  approveInfluencersEffortlesslyModal: {
    autoApprovalEnabled:
      '已开启自动通过。符合规则的达人申请将自动确认。',
    checkSettings: '查看设置',
    notNow: '暂不',
    setupAutoApproval: '设置自动通过',
    approveInfluencersEffortlessly: '轻松审批达人',
    enableAutoApprovalDescription:
      '开启自动通过后，符合预设条件的达人申请将自动确认，无需逐一审核。你可随时在活动信息中修改该设置。',
    influencerAutoApproval: '达人自动通过',
    saveSettings: '保存设置',
    matchingScoreOptional: '匹配分（可选）',
    matchingScoreAbove: '匹配分高于',
    cpmBelowOptional: 'CPM 低于（可选）',
    cpcBelowOptional: 'CPC 低于（可选）',
    fillAllPlatformsError: '请为所有平台填写规则后再提交。',
    letAiPickTitle: '交给 AI 选达人——效果提升 15%+',
    letAiPickDescription:
      '依托数百万次合作数据，AI 代理为你挑选更优达人，平均效果提升 15%+。不满意？随时举报不匹配并申请退款。',
    setRulesNext: '下一步设置规则',
    letAiAgentPickTitle: '让 AI 代理为你挑选达人',
    aiAgentDescription:
      '依托数百万次合作数据，AI 代理为你挑选更优达人，平均效果提升 15%+。不满意？随时举报不匹配并申请退款。',
    aiAgentTitle: 'AI 代理',
    aiAgentSubtitle: '基于预设规则自动确认高潜达人。',
    letAiHandleIt: '交给 AI 处理',
    confirm: '确认',
    matchingScore: '匹配分（可选）',
    cpmBelow: 'CPM 低于（可选）',
    cpcBelow: 'CPC 低于（可选）',
    usd: 'USD'
  },

  // ModalPaymentDetailAfter 组件
  modalPaymentDetailAfter: {
    paymentDetails: '付款明细',
    influencerPayment: '达人费用',
    aiMarketerCost: 'AI 员工薪资',
    aiMarketerCostTooltip:
      '用于平台运营及 7×24 小时协作支持。',
    transactionFee: '支付手续费',
    transactionFeeTooltip:
      '由支付服务商根据支付方式收取。',
    freeCredits: '赠送额度',
    physicalProductSubsidy: '实物产品补贴',
    physicalProductSubsidyDescription:
      'AhaCreator 可按零售价最高 60% 抵扣达人费用。',
    total: '合计',
    paymentSecurityDescription:
      '确认达人后，款项将由平台安全托管。如未按时交付，你可获得 100% 退款。',
    priceNotApprovedDescription:
      '达人尚未确认您的最新报价，将按达人的报价进行支付。',
    creatorsPendingReviewWarning:
      '部分达人尚未对您的最新报价做出回复。若现在继续，将按其当前报价进行支付。',
    guaranteedSafePayment: '支付安全保障',
    poweredBy: '技术支持'
  },

  // ModalRemoveCreatorAfter 组件
  modalRemoveCreatorAfter: {
    removeInfluencerConfirm: '确认拒绝这位达人的合作吗？',
    highScoreDescription:
      '该达人的匹配分高于 80，基于当前设置是你的优先匹配。',
    refineCampaignDescription:
      '如果结果不理想，建议优化以下设置：',
    coreSellingPoints: '核心卖点',
    coreAudiences: '核心受众',
    businessIntroduction: '业务简介',
    goBack: '返回',
    editCampaign: '编辑营销计划',
    rejectAnyway: '仍要拒绝',
    removeCreatorConfirm: '拒绝这位达人？',
    removeCreatorConfirmDescription: '您的意见有助于我们了解您的偏好，并推荐更适合您的影响者。即使是一个简短的注释也可以提高未来匹配的准确性。',
    remove: '拒绝',
    specifyReason: '请填写原因，帮助AI更好的理解您的诉求',
    removeFailed: '拒绝失败，请联系客服。',
    removeSuccess: '拒绝成功',
    removeOptions: {
      audienceMismatch: "受众不匹配",
      tooExpensive: "价格过高",
      wrongAudienceLocation: "受众范围错误",
      engagementLooksFake: "互动看起来不真实",
      contentNotRelevant: "内容不相关",
      postingTooInfrequently: "发布内容过少",
      viewsTooLow: "浏览量过低",
      other: "其他",
    },
  },
  
  // AudienceSample 组件
  audienceSample: {
    useSampleAsGuide: '以示例为参考',
    entrepreneursTitle: '推出新产品的创业者：',
    entrepreneursDescription:
      '在新品上市阶段，创业者需要高效的营销方案来获得初始牵引。AhaCreator 的品牌识别与自动化营销管理，能够帮助他们建立专业的品牌形象并执行针对性投放，推动首批种子用户与品牌知名度。',
    clearInputsTip: '信息描述越清晰具体，达人匹配越精准'
  },
  
  // CampaignCard 组件
  campaignCard: {
    successfully: '成功',
    deleteCampaignTitle: '删除此计划？',
    deleteCampaignContent:
      '删除后，该营销计划将从组织中移除。',
    delete: '删除',
    resumeCampaignTitle: '恢复此营销计划？',
    resumeCampaignContent:
      '恢复后，Jordan 将继续发送新邀请，现有谈判将持续进行。',
    resumed: '已恢复',
    resume: '恢复',
    pause: '暂停',
    edit: '编辑',
    editAndRelease: '编辑并发布',
    paused: '已暂停',
    duplicate: '复制',
    trendCampaign: '趋势活动'
  },
  
  // CampaignMarketingStrategyTag 组件
  campaignMarketingStrategyTag: {
    affiliateMarketing: '联盟分销',
    influencerMarketing: '达人营销'
  },
  
  // ChargeModal 组件
  chargeModal: {
    title: '充值资金',
    availableBalance: '可用余额',
    securePayment: '安全支付',
    extraAdCredits: '每次充值均享额外广告额度',
    refundAvailable: '支持随时 100% 退款',
    priorityAccess: '优先匹配优质达人',
    vipSupport: 'VIP 专属支持和咨询',
    limitedTimeOffer: '限时优惠倒计时',
    depositFunds: '充值',
    poweredBy: '技术支持',
    extraAdCreditsLabel: '额外广告额度',
    failedToGetPaymentAddress: '获取收款地址失败。',
    addAtLeast: '至少充值',
    accountBalanceCover:
      '以确保账户余额可覆盖本次营销计划的预算及其他进行中营销计划的未消耗预算。',
    pleaseAddAtLeast: '请至少充值',
    soYourAccountBalance:
      '以确保账户余额可覆盖本计划预算及其他进行中营销计划的未消耗预算。',
    byProceeding: '继续操作即表示同意我们的',
    termsOfService: '服务条款与退款政策。',
    currency: 'USD',
    placeholder: '$0',
    tooltipMessage:
      '请至少充值 {amount}，以确保账户余额可覆盖本次计划预算及其他进行中计划的未消耗预算。',
    alertMessage:
      '请至少充值 {amount}，以确保账户余额可覆盖本次计划预算及其他进行中计划的未消耗预算。',
    allMajorCards: '支持所有主流信用卡和借记卡。',
    alternativePaymentMethods: '其他支付方式，如银行转账',
    bankTransfer: '银行转账',
    pleaseContact: '请联系',
    onlinePayment: '在线支付',
    bankTransfer1: '银行转账',
    pleaseAddWorkSpace: '请在备注中添加',
    workSpaceName: '(工作空间名称)',
    toTheNotes: '以便正确分配。转账到账后（你将会收到邮件通知），即可创建营销计划。银行转账费用由广告主承担，AhaCreator 将按实际到账金额进行登记。',
    accountName: '账户名称：',
    bankAccountNumber: '银行账户号码：',
    achRoutingNumber: 'ACH 路由号码：',
    fedwireRoutingNumber: 'Fedwire 路由号码：',
    swiftCode: 'SWIFT 代码：',
    bankName: '银行名称：',
    accountLocation: '账户所在地：',
    companyAddress: '公司地址：',
    bankAddress: '银行地址：',
    accountNo: '账户号码：',
    abaRouting: 'ABA 路由：',
    swiftCodeCapitalized: 'SWIFT 代码：',
    bankAddressCapitalized: '银行地址：',
    copyAll: '复制全部',
    copied: '已复制',
    estimatedArrivalTimesMessage: '转账到账时间：ACH（0–2 个工作日），Fedwire（0–1 个工作日），SWIFT（1–3 个工作日，部分地区可能需要 3–5 个工作日）。',
    forDepositDetails: '充值详情，请参考',
    topUpCampaignBudgetGuide: '充值与营销计划预算指南。',
  },
  
  // ChatBotSubscribeModal 组件
  chatBotSubscribeModal: {
    upgradeYourPlan: '升级你的方案',
    plans: {
      free: {
        description: '适合刚开始探索 AhaCreator 的个人用户',
        items: {
          tasks: '4 个任务',
          unlimitedSeats: '不限成员席位',
          dailyContentGeneration: '每日内容生成',
          viralCreativeIdeaGeneration: '爆款创意灵感',
          competitorAndMarketInsights: '竞品与市场洞察'
        }
      },
      starter: {
        description: '适合轻量使用的兴趣与入门用户',
        items: {
          tasks: '10 个任务',
          unlimitedSeats: '不限成员席位',
          dailyContentGeneration: '每日内容生成',
          viralCreativeIdeaGeneration: '爆款创意灵感',
          competitorAndMarketInsights: '竞品与市场洞察'
        }
      },
      pro: {
        description: '为每周多次使用的专业人士打造',
        items: {
          tasks: '40 个任务',
          unlimitedSeats: '不限成员席位',
          dailyContentGeneration: '每日内容生成',
          viralCreativeIdeaGeneration: '爆款创意灵感',
          competitorAndMarketInsights: '竞品与市场洞察'
        }
      },
      max: {
        description: '适合高强度、持续使用的深度用户',
        items: {
          tasks: '150 个任务',
          unlimitedSeats: '不限成员席位',
          dailyContentGeneration: '每日内容生成',
          viralCreativeIdeaGeneration: '爆款创意灵感',
          competitorAndMarketInsights: '竞品与市场洞察'
        }
      }
    },
    downgradeReasons: {
      tooExpensive: '当前需求下价格偏高',
      notUsingFeatures: '高级功能使用不多',
      notMeetExpectations: '与预期不符',
      foundAlternative: '已找到更合适的替代方案',
      otherReasons: '其他原因'
    },
    // DowngradeConfirmModal 相关文本
    downgradeModal: {
      switchTo: '切换至',
      plan: '方案',
      youAreDowngradingTo: '你将降级到',
      willLoseAccess: '降级后你将失去以下功能：',
      maybeLater: '以后再说',
      successToDowngrade: '降级成功',
      currentPlanExpire: '当前方案到期日：',
      somethingWeCouldDoBetter: '我们可以做得更好吗？欢迎告诉我们降级原因。',
      letUsKnowHowToImprove: '告诉我们如何改进',
      otherReasonsText: '其他原因'
    },
    // PlanItem 相关文本
    planItem: {
      yearly: '年付',
      perYear: '/年',
      perMonth: '/月',
      youAreOnThisPlan: '你正在使用此方案',
      youAreOnThisPlanWithEmoji: '你正在使用此方案 🎉',
      upgrade: '升级',
      downgrade: '降级',
      successToUpgrade: '升级成功'
    }
  },

  // ContactUs 组件相关文本
  contactUs: {
    discord: 'Discord',
    joinImmediately: '立即加入',
    email: '邮箱',
    contactSupport: '联系支持',
    bookAMeeting: '预约专家会议',
    contactHumanExpert: '联系人工专家'
  },

  // CoreAudiencesForm 组件相关文本
  coreAudiencesForm: {
    audienceDefinitionsCritical:
      '你的受众画像描述至关重要，它直接影响 AhaCreator 为你匹配的达人质量。越具体、越准确，匹配结果越符合预期。',
    viewExamples: '查看示例',
    number: '序号',
    title: '标题与描述',
    audiencesPrefilledInfo:
      '以下受众由 AhaCreator 根据你的营销计划预填，请按需检查，编辑与完善。',
    pleaseEnterAudienceName: '请输入受众名称',
    enterTitle: '输入标题',
    pleaseEnterAudienceDescription: '请输入受众描述',
    enterDescription: '输入描述',
    add: '添加',
    examples: {
      startupFounders: {
        title: '希望用自动化提升营销效率的初创创始人',
        description:
          '资源有限的创业者需要高性价比的营销方案。AhaCreator 的端到端代理式管理，让他们无需庞大团队也能开展专业的多平台红人营销，在控制成本的同时加速增长。'
      },
      enterprises: {
        title: '追求规模化与持续优化的企业团队',
        description:
          '大型企业需要快速扩张且持续优化的营销能力。AhaCreator 的企业级平台自动化创建与测试多渠道营销，持续分析表现并优化策略，帮助团队在复杂市场与庞大客群中稳定增长。'
      },
      agencies: {
        title: '需要规模化内容与服务的代理商',
        description:
          '代理商需为多客户持续产出高质量内容与策略。AhaCreator 的协作式平台加速达人内容生产、创意发想与报告，让代理商在不扩编的情况下提升产能并保持质量。'
      }
    }
  },

  // CoreSellingPointsForm 组件相关文本
  coreSellingPointsForm: {
    number: '序号',
    description: '描述',
    pleaseInputCoreProductFeatures: '请输入核心产品特性',
    pleaseInputInfluencerPersonas: '请输入期望达人画像',
    add: '添加'
  },

  // CreateEstimatePanel 组件相关文本
  createEstimatePanel: {
    views: '曝光',
    cpm: 'CPM',
    clicks: '点击',
    cpc: 'CPC',
    usd: 'USD',
    costPerInstallRange: '每次安装成本区间',
    installRange: '安装量区间',
    costPerLeadRange: '每条线索成本区间',
    leadRange: '线索量区间',
    costPerSignUpRange: '每次注册成本区间',
    signUpRange: '注册量区间',
    roiRange: 'ROI 区间',
    salesRange: '销售额区间',
    arpuCacRange: 'ARPU/CAC 区间',
    aovCacRange: 'AOV/CAC 区间',
    roi: 'ROI'
  },

  // EstimatePanelNew 组件相关文本
  estimatePanelNew: {
    estimatedCampaignResults: '营销计划效果预估',
    affiliateMarketingResultsEstimation: '联盟分销效果预估',
    coldEmailResultsEstimation: '邮件营销效果预估',
    views: '曝光',
    cpm: 'CPM',
    clicks: '点击',
    cpc: 'CPC',
    usd: 'USD',
    costPerInstallRange: '每次安装成本区间',
    installRange: '安装量区间',
    costPerLeadRange: '每条线索成本区间',
    leadRange: '线索量区间',
    costPerSignUpRange: '每次注册成本区间',
    signUpRange: '注册量区间',
    roiRange: 'ROI 区间',
    salesRange: '销售额区间',
    arpuCacRange: 'ARPU/CAC 区间',
    aovCacRange: 'AOV/CAC 区间',
    roi: 'ROI',
    cpmAcrossDifferentPlatforms: '不同平台的 CPM 对比',
    showLess: '收起',
    viewAll: '查看全部',
    numberOfAffiliates: '联盟成员数量',
    noteSalesEstimates:
      '说明：销售额预估基于 1.5%–4.5% 的行业点击-到-购买转化基准计算。',
    potentialConvertedLeads: '潜在成交线索',
    potentialCustomers: '潜在客户数',
    potentialLifetimeRevenue: '潜在用户生命周期收入'
  },

  // GlobalAlert 组件相关文本
  globalAlert: {
    lowBudgetInfluencer: {
      title: '您的营销计划 {campaignName} 预算偏低',
      desc: '预算将直接影响可邀请的达人数量。立即提升预算，解锁更多合作机会，最大化结果。',
      confirmText: '增加预算',
      cancelText: '查看计划信息'
    },
    campaignPaused: {
      title: '你的营销计划 {campaignName} 因不活跃已暂停',
      desc: '要继续匹配并推进流程，请立即恢复计划。',
      confirmText: '重启这个营销计划',
      cancelText: '查看计划详情'
    },
    campaignApproved: {
      title: '营销计划已通过审核：{campaignName}',
      desc: '你的计划已成功通过审核并上线！',
      confirmText: '查看营销计划',
      cancelText: '知道了'
    },
    campaignRejected: {
      title: '需要操作：你的营销计划 {campaignName} 需更新',
      desc: '当前无法通过审核。请查看反馈，完成必要修改后重新提交。',
      confirmText: '查看反馈',
      cancelText: '知道了'
    }
  },

  // HeadContainer 组件相关文本
  headContainer: {
    defaultTitle: '用 AI 为创作者合作带来 Aha moments',
    analyzing: 'AhaCreator 正在分析…',
    working: 'AhaCreator 正在处理…'
  },

  // HighQualityCard 组件相关文本
  highQualityCard: {
    header: 'AhaCreator 正在为您精心筛选优质达人来为您的投放效果保驾护航',
    recentlyActive: {
      title: '近期活跃',
      desc: '近 {days} 天内发布过内容'
    },
    highEngagementRate: {
      title: '高互动率',
      desc: '互动率高于 AhaCreator 阈值'
    },
    performanceAuthenticity: {
      title: '数据真实',
      desc: '未检测到虚假曝光或互动'
    },
    goodCredit: {
      title: '信用良好',
      desc: '无违反 AhaCreator 合同记录'
    }
  },
  modal: {
    changeBudget: {
      title: '增加预算',
      confirm: '确认',
      assistanceText: '如需帮助，欢迎',
      contactUs: '联系我们。',
      budgetUpdated: '预算已更新'
    }
  },

  // MatchInfluencerAdjustModal 组件
  matchInfluencerAdjustModal: {
    title: '优化营销计划以获取更多精准达人',
    description: '营销计划信息越清晰、明确，AhaCreator 越能为你匹配到更相关的达人',
    businessIntroduction: '业务简介',
    coreSellingPoints: '核心卖点',
    coreAudiences: '目标受众画像',
    introPlaceholder:
      '请简要说明产品核心价值与独特点，力求简洁有力。',
    introRequired: '请输入您的产品/品牌介绍',
    coreFeatureRequired: '请输入核心产品特性',
    add: '添加',
    titleLabel: '标题',
    descriptionLabel: '描述',
    titlePlaceholder: '输入标题',
    descriptionPlaceholder: '输入描述',
    audienceTitleRequired: '请输入受众画像',
    audienceDescriptionRequired: '请输入对这个受众画像的描述',
    cancel: '取消',
    updateButton: '更新以提升匹配',
    successMessage:
      '已根据你的输入更新达人匹配。之后您将看到更符合最新需求的达人。'
  },

  // MessageGuarantee 组件
  messageGuarantee: {
    organicTraffic: {
      title: '100% 自然流量',
      description: '以真实流量最大化营销推广效果'
    },
    deliveryGuarantee: {
      title: '交付保障',
      description: '达人未交付可 100% 退款'
    },
    lowestPrice: {
      title: '更优价格',
      description: '以最低 CPM 与品牌内容预估曝光，确保定价更优'
    }
  },

  // DrawFeedback 组件
  drawFeedback: {
    // 按钮和标题
    provideFeedback: '请求修改',
    feedback: '反馈',
    cancel: '取消',
    sendFeedback: '发送反馈',
    quickFeedback: '快速反馈',
    sendRevisedFeedback: '发送修订后的反馈',
    consolidateFeedbackTip: '请在发送前整合您的反馈，频繁更改可能会降低达人的合作意愿并延迟交付。',
    editFeedbackSuccess: "你的反馈已成功更新，达人已收到通知。",

    // 标签页
    platformRequirements: '平台要求',
    brandRequirements: '品牌要求',
    
    // 选项标题
    videoLength: '视频时长',
    endingCTA: '结尾 CTA',
    description: '描述区',
    timestamp: '时间戳',
    music: '配乐',
    content: '内容',
    tweet: '推文',
    captions: '字幕/文案',
    tagMention: '标签与提及',
    seamlessIntegration: '自然融合',
    smoothTransitions: '顺滑转场',
    complementaryNarration: '补充讲述',
    consistentAesthetic: '风格一致性',
    
    // 选项内容
    videoLengthContent: '建议整体视频时长不少于 5 分钟',
    endingCTAContent: '在视频结尾清晰表达行动指引',
    descriptionContent: '在描述中加入强力的品牌/产品 CTA',
    descriptionContent2: '使用 AhaCreator 提供的推广链接',
    timestampContent: '请创建时间戳',
    musicContent: '检查版权合规',
    endingCTAContent2:
      '在视频结尾清晰提示：“更多信息请查看描述中的链接”。',
    descriptionContent3:
      '在描述开头与置顶首评加入强力 CTA。',
    descriptionContent4:
      '请使用 AhaCreator 提供的推广链接，勿使用官网或跳转链接。（除非与广告主沟通）',
    musicContent2:
      '请确保背景音乐、音效与片段不存在任何国家的版权风险。',
    
    // TikTok 选项
    tiktokVideoLength:
      '你的视频少于 30 秒。请延长至 30 秒至 2 分钟之间。',
    tiktokContent:
      '缺少清晰的口播或文字 CTA。请加入如“查看推文中的链接获取优惠码和更多信息”。',
    tiktokTweet:
      '开头力度不足。建议修改为：“来看我们的最新视频，发现超值优惠！链接”。',
    tiktokTweet2: '缺少相关话题标签，请补充合适的标签。',
    tiktokTweet3: '不需要@品牌官方账号，请移除。',
    
    // Instagram 选项
    instagramVideoLength:
      '视频时长不足 20 秒。请延长至 20 秒以上。',
    instagramEndingCTA:
      '缺少“查看主页链接”的结尾 CTA，且优惠码未在画面显示。',
    instagramCaptions:
      '文案开头缺少强力 CTA。请加入“使用优惠码立减 XX%！立即前往主页点击链接！”并补充相关标签。',
    instagramCaptions2: '缺少相关话题标签。',
    instagramTagMention: '无需@品牌官方账号，请移除。',
    
    // Twitter/LinkedIn 选项
    twitterVideoLength:
      '你的视频少于 30 秒。请延长至 30 秒至 2 分钟之间。',
    twitterContent:
      '缺少清晰的口播或文字 CTA。请加入如“查看推文链接获取更多信息与独家优惠码”。',
    twitterTweet:
      '开头力度不足。建议修改为：“来看看我们的最新视频，发现超值优惠！链接”。',
    twitterTweet2: '缺少相关话题标签，请补充。',
    twitterTweet3: '不需要@品牌官方账号，请移除。',
    
    // 物理产品选项
    physicalSeamlessIntegration:
      '在合适位置融入所提供的素材片段，使其与常规风格自然衔接并保持真实感。',
    physicalSmoothTransitions:
      '在提供的片段与原始素材之间设计顺滑转场，保证整体流畅统一。',
    physicalComplementaryNarration:
      '通过旁白或字幕补充讲解产品特性，使内容更具信息性与吸引力。',
    physicalConsistentAesthetic:
      '在光线、色调与风格上与原素材保持一致，确保视觉统一。',
    
    // 模态框
    feedbackLimitTitle: '最多可提交 4 次反馈',
    feedbackLimitContent:
      '为确保及时交付与顺畅协作，请尽量在前期一次性提交完整反馈。',
    gotIt: '知道了',
    
    // 通知消息
    approved: '已通过！',
    feedbackSubmitted: '反馈提交成功！',
    creatorWillProvide:
      '达人将提供修订稿。上传后请及时审核并给出完整修改意见或确认。',
    creatorWillProvideFirst:
      '达人将提供首版视频草稿。上传后请及时审核并给出完整修改意见或确认。',
    creatorWillProvideBefore:
      '达人将于 {dateTime} 前提交修订稿。为保障协作效率，请及时审核。',
    creatorWillPublish:
      '达人将于 {dateTime} 前发布内容，敬请关注！'
  },

  // ModalSetUpCampaignData 组件
  modalSetUpCampaignData: {
    // 按钮文本
    notNow: '暂不',
    confirmChange: '确认修改',
    ok: '好的',
    
    // 标题和描述
    head: 'AhaCreator',
    campaignEdited: '营销计划已更新',
    
    // 邮件服务相关
    feelFreeToContact: '如需帮助可联系：{email}',
    letMeKnow: '如有其他需要，随时告诉我：）',
    
    // 表单字段标题
    locations: '地区',
    placements: '投放平台',
    languages: '语言',
    coreSellingPoints: '核心卖点',
    customBrandGuidelines: '自定义品牌规范',
    optimizedAudiences: '优化受众',
    
    // 必填标记
    required: '*',
    
    // 工具提示
    locationsTooltip: '选择更广的投放区域有助于提升结果。',
    placementsTooltip: '选择你希望达人使用的社交平台与内容形式。',
    languagesTooltip: '输入投放语言，触达使用该语言的人群。',
    coreSellingPointsTooltip:
      '请说明你的内容优化偏好（如引流按钮位置/标签样式），我们会同步给达人。',
    
    // 表单验证消息
    selectAtLeastOneRegion: '请至少选择一个地区',
    selectAtLeastOnePlatform: '请至少选择一个平台内容类型',
    selectedPlatformsLimitReach:
      '当前选择可能限制触达范围。为取得更好效果，建议增加更多平台。',
    
    // 占位符
    selectAll: '全选',
    platformContentTypePlaceholder: '请至少选择一个平台内容类型',
    customGuidelinesPlaceholder: '例如：请务必使用 xxx 功能。',
    
    // 预算相关
    setYourMaximumCpm: '手动设置你的最高 CPM',
    chooseYourBudgetLimit: '选择你的预算上限',
    setHighestBudgetPerInfluencer:
      '设置单达人最高预算：超过该额度的达人将不会被邀请',
    setLowestBudgetPerInfluencer:
      '设置单达人最低预算：超过该额度的达人将不会被邀请',
    
    // 货币单位
    usd: 'USD',
    
    // 添加/删除按钮
    add: '添加',
    
    // 最大数量限制
    maxCount: '20',
    mustDoMaxCount: '10'
  },

  // AffiliateNoRechargeModal 组件
  affiliateNoRechargeModal: {
    // 标题和称呼
    dearUser: '亲爱的用户，',
    
    // 主要内容
    strategicAdjustment:
      '受市场影响，我们将暂时不提供联盟分销服务。',
    changeNotAffect:
      '此变更不影响任何进行中的合作，也不影响达人营销功能，你仍可继续使用达人营销解决方案。',
    contactForQuestions: '如有疑问，请联系我们：',
    email: '邮箱：',
    appreciation: '感谢您的理解与配合。',
    
    // 按钮
    gotIt: '知道了'
  },

  // SuggestionInput 组件
  suggestionInput: {
    additionalFeedback: '补充反馈',
    addCustomizedFeedback: '添加自定义反馈',
    delete: '删除'
  },

  // ModalConfirmPrompt 组件
  modalConfirmPrompt: {
    title: '内容已通过！',
    confirm: '确认',
    cancel: '取消',
    description: '以下建议可帮助你在后续合作中减少沟通成本：',
    slides: {
      slide1: {
        title: '清晰表达目标',
        content: '本视频需推动用户点击网站链接并注册。'
      },
      slide2: {
        title: '提供清晰脚本建议/大纲',
        content: '请包含开箱环节，并突出我们的极速配送服务。'
      },
      slide3: {
        title: '给出参考或品牌语气',
        content: '我们喜欢这条 TikTok 的节奏可作为参考（+链接）。'
      },
      slide4: {
        title: '明确禁用或敏感话题',
        content: '请避免提及其他品牌，尤其是竞品。'
      },
      slide5: {
        title: '指定偏好的基调与风格',
        content: '希望整体偏轻松、Vlog 风。'
      }
    }
  },

  icons: {},
  loading: {},
  tutorial: {},
  campaign: {},
  order: {},
  payment: {},
  notification: {},
  form: {},
  chart: {},
  table: {},
  card: {},
  button: {},
  input: {},
  select: {},
  alert: {},
  banner: {},
  sidebar: {},
  footer: {},
  header: {},
  content: {},
  wrapper: {},
  container: {},
  layout: {},
  grid: {},
  flex: {},
  text: {},
  image: {},
  video: {},
  audio: {},
  file: {},
  link: {},
  badge: {},
  tooltip: {},
  popover: {},
  dropdown: {},
  menu: {},
  breadcrumb: {},
  pagination: {},
  tabs: {},
  accordion: {},
  carousel: {},
  slider: {},
  progress: {},
  spinner: {},
  skeleton: {},
  empty: {},
  error: {},
  success: {},
  warning: {},
  info: {},

  // modalAddOrderEnd
  modalAddOrderEnd: {
    title: '通过扩展国家、语言或平台来放大投放效果',
    okText: '编辑计划',
    cancelText: '暂不',
    description:
      '基于你当前的选择，我们已从超过 5,000 万达人的库中触达所有匹配对象，但你的营销计划仍有未消耗预算。为进一步扩大效果，建议',
    expandingText: ' 扩展更多国家、语言或社交平台 ',
    reachBroaderAudience: '以触达更广泛的受众。',
    promptTitle: '通过扩展选择放大投放效果',
    promptDescription: '根据您当前的设置，已联系到所有符合条件的达人，但您的活动仍有未使用的预算。为了扩大您的覆盖范围，请尝试扩展<b>国家、语言或平台</b>，或调整您的<b>匹配准确度</b>以发现更多潜在的匹配。',
    editCampaignButton: '编辑计划',
    tutorialTitle: '教学视频'
  },

  modalAddPayment: {
    title: '添加付款信息',
    cancel: '取消',
    next: '下一步',
    topUpAmount: '充值金额',
    addFunds: '预存资金',
    addFundsDesc:
      '选择预存后，你会先向平台充值。该计划运行产生费用时，将从余额中扣减。',
    addCard: '绑定银行卡',
    addCardDesc:
      '选择绑定银行卡后，营销计划运行产生费用会自动扣款。'
  },

  modalApprove: {
    approve: '通过（添加备注）',
    approveTooltip: '你可以在审核过程中添加备注，并设置达人预期的发布时间。',
    confirmToApproveScript: '确认通过脚本',
    approveContent: '通过内容',
    confirm: '确认',
    approveAndSendToInfluencer: '通过并发送给达人',
    scriptApprovalNote:
      '请注意：脚本通过后，达人将开始正式制作内容。',
    contentApprovalNote:
      '请选择预期发布时间并向达人备注，有助于按时交付与清晰沟通。',
    notes: '备注',
    addNotesToInfluencer: '向达人添加备注',
    publishTime: '发布时间',
    publishTimeMessage: "请设置发布时间窗口大于12小时。",
    addNotes: '添加备注',
    scriptApproved: '脚本已通过！',
    firstDraftMessage:
      '该达人将于 {dateTime} 前提供首版内容草稿。请及时审查并提供反馈，以保持合作顺利进行。',
    publishDeadlineMessage:
      '该达人将于 {dateTime} 前发布内容，敬请关注！',
    publishDeadlineAndNotesSent:
      '已将发布时间与备注发送给达人，对方需按时发布。',
    approved: '已通过！',
    cancel: '取消'
  },

  modalCompleteCollaboration: {
    completeCollaboration: '完成合作'
  },

  modalCompleteCollaborationSuccess: {
    gotIt: '知道了',
    completeCollaboration: '合作已完成！',
    startTrackingMessage: '前往报告页开始查看投放表现吧！'
  },

  modalXTip: {
    twitterPostTooltip: "X 可能包含更多营销账号。请仔细审核账号，并在合作前确认公平报价。",
    engagementPod: "什么是营销账号？",
    modalTitle: "什么是营销账号？",
    Definition: "定义",
    definitionContent: "营销账号是指一类 X 网红账号，通过多个账号互相转发和评论来制造人气和互动。表面上看起来讨论热烈，但实际上互动可能是人工制造的，真实影响力不一定能匹配真实转化。",
    CommonFeatures: "常见特征（越符合，越需要谨慎）",
    commonFeaturesContent1: "互相转发和互相评价明显：评论/转发长期集中在同一组账号中，账号间高频互赞和互影响。评论质量低：评论多为模板化、空洞赞美或与内容无关，重复率高。",
    commonFeaturesContent2: "评论质量低：评论多为模板化、空洞赞美或与内容无关，重复率高。",
    WhyShouldWePayAttention: "为什么需要关注？",
    whyShouldWePayAttentionContent1: "数据可能被夸大：人气来自圈子互相“刷”出来的。",
    whyShouldWePayAttentionContent2: "效果不稳定：真实曝光度、信任度和转化率可能较低。",
    whyShouldWePayAttentionContent3: "报价可能不合理：基于夸大的互动给出高价。",
  },

  modalConfirmCreator: {
    paymentFailedTryAgain: '支付失败，请重试。',
    paymentSuccessful: '支付成功！',
    confirmAndPayFailed: '确认并支付失败：{error}',
    confirmAndIncBudgetFailed: '确认并增加预算失败：{error}',
    confirmAndPay: '确认并支付',
    confirm: '确认',
    cancel: '取消',
    campaignBudgetLimitReached: '预算上限已达',
    budgetLimitWarning:
      '提示：通过该达人将使本次营销预算超出上限。',
    wouldYouLikeToProceed: '仍要继续吗？'
  },

  modalContentGuidance: {
    addCreativeDirectionOptional: '添加创作指引（可选）',
    addCreativeDirection: '添加创作指引',
    sharePreferencesMessage:
      '可分享偏好或示例，为该达人的内容创作提供方向',
    creativeDirection: '创作指引',
    submit: '提交',
    creativeDirectionSuccessMessage: '已成功向达人分享创作指引',
    influencerMarketing: '达人营销',
    affiliateMarketing: '联盟分销'
  },

  modalDelayTwoDays: {
    postponeTimeline: '推迟时间线',
    maxPostponeTooltip:
      '已达到可推迟次数上限。如需更多协助，请联系支持。',
    areYouSureToPostpone: '确定要推迟时间线吗？',
    confirm: '确认',
    postponeNote:
      '每个计划最多可推迟 5 次，每次最多可延长 2 个工作日。',
    confirmSuccess: '确认成功',
    confirmFailed: '确认失败'
  },

  modalFeedbackSuccess: {
    gotIt: '知道了',
    feedbackSubmittedSuccessfully: '反馈提交成功！'
  },

  modalPauseReason: {
    pauseCampaignTitle: '暂停计划 — 请告诉我们原因',
    helpUnderstandNeeds:
      '为更好理解你的需求并改进体验，请选择本次暂停的原因',
    otherFeelFreeToShare: '其他——欢迎补充说明',
    cancel: '取消',
    pauseCampaign: '暂停计划',
    paused: '已暂停',
    reasonTypes: {
      dontNeedToPromote: '该产品已无需推广',
      influencersTooExpensive: '达人费用过高',
      influencersDontMatchBrand: '达人不符合品牌调性',
      alreadyFoundEnough: '已在其他渠道找到足够达人',
      performanceLowerThanExpected: '投放效果低于预期'
    }
  },

  modalPaymentDetails: {
    confirm: '确认',
    paymentDetails: '付款明细',
    influencerPayment: '达人费用',
    recruitmentFee: '招募费用',
    aiMarketerCost: 'AI 员工薪资',
    aiMarketerCostTooltip: '用于平台运营及 7×24 小时协作支持。',
    transactionFee: '交易手续费',
    transactionFeeTooltip: '由支付服务商根据支付方式收取。',
    freeCredits: '赠送额度',
    physicalProductSubsidy: '实物产品补贴',
    physicalProductSubsidyDescription: 'AhaCreator 可按零售价最高 60% 抵扣达人费用。',
    total: '合计',
    securePaymentNote:
      '确认达人后，款项将由平台安全托管。如未按时交付，你可获得 100% 退款。',
    guaranteedSafeSecure: '支付安全保障',
    poweredBy: '技术支持'
  },

  modalPaymentMoney: {
    next: '下一步',
    failedToGetPaymentAddress: '获取收款地址失败。'
  },

  modalRechargeResult: {
    checking: '检测中…',
    rechargeFailedTryAgain: '充值失败，请重试。',
    accountCreditedMessage: '{amount} 美元已添加到你的余额。',
    subscriptionSuccess: '订阅成功',
    subscriptionFailedTryAgain: '订阅失败，请重试。',
    youreAllSet: '一切就绪！',
    paymentMethodConfirmed:
      '你的支付方式已确认。我们已为你的营销计划解锁',
    fullInfluencerOutreach: '全量达人外联',
    forYourCampaign: ' —— 正在匹配与发送邀请。',
    gotIt: '查看余额',
    topUpComplete: '充值完成！',
    campaignDepositSuccessful: '保证金支付成功 🎉',
    campaignAlmostReadyActive:
      '您的计划即将上线。点击“更新营销计划”以发布最新更改。',
    campaignAlmostReady:
      '您的计划就绪在即！请完成必要的企业验证与授权，以正式发布营销计划。',
    updateCampaign: '更新计划',
    completeSetup: '完成设置'
  },

  modalRemoveCreator: {
    remove: '拒绝',
    refuseCooperationTitle: '确定要拒绝此次合作吗？',
    refuseCooperationDescription:
      '该达人已接受您的最新报价，此时拒绝合作将……',
    declineProposal: '拒绝合作',
    areYouSureToRemoveInfluencer: '确定要拒绝此达人吗？',
    highScoreMessage: '该达人的匹配分高于 80，是当前计划中的高分达人。',
    considerRefiningMessage:
      '如果结果不理想，建议优化以下设置：',
    coreSellingPoints: '核心卖点',
    coreAudiences: '核心受众',
    businessIntroduction: '业务简介',
    goBack: '返回',
    editCampaign: '编辑计划',
    rejectAnyway: '仍要拒绝',
    removeThisCreator: '拒绝此达人？',
    removeButton: '移除',
    pleaseSpecifyReason: '请填写原因',
    removeFailedContactSupport: '拒绝失败，请联系支持。',
    removeSuccess: '拒绝成功',
    creatorLanguageNotMeet: '达人的语言不符合要求',
    creatorAudienceNotMeet: '达人的受众不符合要求',
    campaignBudgetFullyAllocated: '本次计划的营销预算已全部分配',
    creatorCoordinatedNetwork:
      '达人疑似参与刷数据网络，频繁互转评赞以虚增互动数据。',
    other: '其他',
    cancelConfirmedCollaborationsTitle: '确认要取消这些合作吗？',
    cancelConfirmedCollaborationsDescription: '这些达人已接受你的报价。取消后，他们将收到合作已取消的通知。',
  },

  modalRemoveOrConfirm: {
    feedbackHelpsMatch: '你的反馈有助于 AhaCreator 为你匹配更优达人',
    goodNewsMessage:
      '好消息！已有达人对您本次的营销计划感兴趣。现在就通过或拒绝他们，AhaCreator 将依据你的反馈即时优化匹配。',
    gotIt: '知道了'
  },

  modalShipInformation: {
    enterShippingInformation: '填写发货信息',
    shippingInformation: '发货信息',
    confirm: '确认',
    carrier: '物流承运商',
    pleaseSelectCarrier: '请选择承运商',
    trackingNumber: '运单号',
    pleaseEnterTrackingNumber: '请输入运单号',
    weCantRetrieveYourShipmentDetailsRightNow: '我们无法获取你的发货信息。请确认运单号。如果正确，可能是数据同步延迟，状态将在可用时更新。',
    somethingWentWrongWhileLoadingLogisticsInfo: '加载物流信息时出错。请稍后再试。'
  },

  modalUpdatePlan: {
    unknownError: '未知错误',
    subscriptionCanceledSuccessfully: '订阅取消成功',
    subscriptionDowngradedSuccessfully: '订阅降级成功',
    subscriptionUpgradedSuccessfully: '订阅升级成功',
    employmentPricingModelMessage:
      '你选择了“雇佣式计费”，请先购买方案以发布活动。',
    campaignBudgetExceededMessage:
      '当前活动预算已超过剩余达人配额。',
    upgradePlanQuestion:
      '是否将方案升级至 {budget} 并继续发布该活动？',
    chooseMonthlyBudgetMessage:
      '请选择每月达人预算，随后前往 Stripe 完成订阅。',
    selectUpgradePlanMessage: '请选择你希望升级的方案，升级将立即生效。',
    confirmDowngradeMessage:
      '请确认你将降级方案。此变更将于 {date} 生效。',
    subscriptionCancelMessage:
      '你当前的订阅将于下月起取消。届时将切换为“自由职业计费”，每次达人合作将收取 10% 平台佣金。',
    selectCreatePlanMessage:
      '请选择你希望创建的订阅方案，变更将立即生效。',
    defaultMessage:
      '请选择订阅方案。如遇问题，请联系客户支持。',
    purchase: '购买',
    downgradeSubscription: '降级订阅',
    proceed: '继续',
    upgradeSubscription: '升级订阅',
    notNow: '暂不',
    cancel: '取消',
    purchaseYourPlan: '购买你的方案',
    downgradeSubscriptionPlan: '确认要降级订阅方案？',
    cancelSubscriptionPlan: '确认要取消订阅方案？',
    upgradeYourSubscription: '升级你的订阅'
  },

  modalWarning: {
    affiliateIntegrationNeeded: '需要完成联盟分销集成',
    integrationMessage:
      '为确保准确统计与及时结算佣金，请尽快按照以下文档完成集成：',
    affiliateIntegrationDocumentation: '《联盟分销集成文档》',
    continueSetup: '继续设置'
  },

  stripeCardFormContent: {
    pleaseFillCompleteBillingAddress: '请完整填写账单地址信息',
    cardBindingSuccessful: '绑卡成功。',
    errorDuringCardBinding: '绑卡出错，请重试。',
    submit: '提交'
  },

  terminateCollaboration: {
    cancelCollaboration: '取消合作',
    confirmation: '确认',
    cancel: '取消',
    notNow: '暂不',
    confirmCancellationOfCollaboration: '确认取消此次合作',
    cancellationWarning:
      '请注意：取消后不可恢复，请谨慎操作。'
  },

  notLikeFeedBackModal: {
    feedback: '反馈',
    submit: '提交',
    cancel: '取消',
    othersPlaceholder:
      '（可选）欢迎分享任何意见或建议，帮助我们改进。感谢你的反馈！'
  },

  orderStatusComponent: {
    pendingSelection: '待选择',
    quoteRequested: '待报价',
    lateProductionKickoff: '未按时启动制作',
    lateAddressSubmission: '收件地址逾期提交',
    lateSubmission: '内容逾期提交',
    tooltipMessage:
      '因逾期交付，此合作可取消并全额退款；即便取消，你仍保留已产出的 UGC 使用权。',
    slightlyBehindSchedule: '进度略有延迟',
    behindScheduleTooltip:
      '达人提交稍有延后，我们的 AI 正在主动提醒以推动进度。',
    // Order status labels
    pendingPayment: '已确认价格',
    collaborationEstablished: '新候选人',
    counterOfferUnderAdvertiserReview: '达人报价待广告主审核',
    priceProposalUnderInfluencerReview: '广告主报价待达人审核',
    pendingProductionKickoff: '待启动制作',
    pendingCreatorAddress: '待达人提供地址',
    underScriptProduction: '脚本制作中',
    underScriptReview: '脚本审核中',
    underContentProduction: '内容制作中',
    underContentReview: '内容审核中',
    adsPendingPublish: '内容待发布',
    adsPublished: '内容已发布',
    collaborationCancelled: '合作已取消',
    pendingProductShipment: '待寄送产品',
    pendingProductArrival: '待确认收货',
    collaborationWithdrawn: '达人已撤回',
    expired: '已过期',
    pendingCreatorAccountInfo: '等待达人提供账号访问信息',
    pendingAccountSetup: '账号信息已提交，待品牌方开通',
    pendingAccountSetupTooltip: '及时反馈建立信任，保持活动在正轨上。',
    pendingCreatorAccountInfoTooltip: '等待达人提交账号信息。',
    underAdsReviewTooltip: '达人最新报价已发送给你，等待你审核。',
    underCreatorReviewTooltip: '你的最新出价已发送给达人，等待达人审核。',
    pendingAdsApprovalTooltip:
      '达人已接受你的出价，你可立即支付以确认合作。款项由平台托管，内容发布 10 天后将释放给达人。',
  },

  paymentFailedAlert: {
    paymentFailed: '支付失败',
    paymentFailedDescription:
      '我们在处理你的支付时遇到问题，已暂停进行中的。请检查付款方式并重试。如需帮助请联系支持。',
    updatePaymentMethod: '更新支付方式'
  },

  paymethodModal: {
    depositFundsNow: '立即充值',
    addACard: '绑定卡片'
  },

  productLogo: {
    youCanOnlyUploadSvgFile: '仅支持上传 SVG 文件！',
    fileSizeCannotExceed10MB: '文件大小不可超过 10MB！',
    failedToUploadLogo: '上传 Logo 失败',
    upload: '上传'
  },

  shareDialogue: {
    copySuccess: '复制成功',
    copyFail: '复制失败',
    shareTemplate: '分享模板',
    publicAccess: '公开访问',
    anyoneWithThisLinkCanView: '持链接者可查看',
    share: '分享',
    copy: '复制',
    copied: '已复制',
    shareMyTaskInTheOfficialUseCaseGallery: '将我的任务分享到官方案例库'
  },

  submitHistory: {
    copiedAdAuthorizationCode: '已复制广告授权码',
    appliedOn: '申请时间：',
    confirmedOn: '确认时间：',
    submittedOn: '提交时间：',
    creativeDirection: '创作指引',
    script: '想法/脚本',
    video: '视频',
    draft: "草稿",
    final: "终稿",
    link: '链接：',
    caption: '草稿描述：',
    adAuthorizationCode: '广告授权码：',
    videoDescription: '视频描述：',
    draftDescription: "草稿描述:",
    postCaptionDescription: '帖文文案/描述：',
    thumbnail: '封面：',
    influencersNote: '达人备注',
    yourFeedback: '你的反馈',
    edit: '编辑',
    yourNote: '你的备注',
    requirements: '要求',
    additionalSuggestions: '补充建议',
    creatorHasNotUploadedAnyContent: '该达人尚未上传任何内容',
    contentPublishTime: '内容发布时间：',
    influencerExpectedToSubmitFinalPostLink:
      '达人预计在此期间提交最终发布链接。',
    feedbackProvided: '已反馈',
    dealCanceled: '合作已取消',
    underReview: '审核中',
    approved: '已通过',
    submitted: '已完成',
    skipped: '已跳过',
    skippedSystemText: '达人选择跳过脚本环节，直接进入视频制作。',
    rejected: "已拒绝",
    cancelled: "已取消",
    timelineExtension: "时间线延期",
    approve: "批准",
    requestSubmittedAt: "请求提交时间",
    originalDeliveryDate: "原定交付日期",
    newDeliveryDate: "新交付日期",
    notesFromInfluencer: "达人备注",
    rejectedReason: "拒绝原因",
    approveSuccess: "您已成功批准时间线延期！达人将收到时间线更新的通知。",
    reviewIdeaScript: "审核想法/脚本",
    reviewDraft: "审核草稿"
  },

  tableCreatorName: {
    influencerMatchedFromReference: '该达人来自你的参考达人匹配',
    following: '已关注',
    estimatedViewsPost: '预估曝光/帖',
    match: '匹配'
  },
  matchFromTag: {
    matchedFrom: '匹配自 {brandName}',
  },

  timezone: {
    loading: '加载中…',
    timezoneSaved: '时区已保存！',
    timezoneSaveFailed: '时区保存失败！',
    save: '保存'
  },

  trackingApiKey: {
    apiKeysForTrackingMetrics: '用于追踪指标的 API Key',
    apiKeyManagement: 'API Key 管理',
    generateNewApiKey: '生成新 API Key',
    newApiKeyGenerated: '已生成新的 API Key',
    makeSureToCopyNow: '请立即复制，之后将无法再次查看。',
    activeApiKeys: '生效中的 API Key',
    loading: '加载中…',
    noActiveApiKeys: '暂无生效的 API Key',
    created: '创建时间：',
    revoke: '吊销'
  },

  verifyInput: {
    pleaseEnterValidCode: '请输入有效的验证码'
  },

  viewReportCard: {
    viewReport: '查看报告'
  },

  creatorTodoCard: {
    waiting: '等待中',
    reviewTimelineExtension: '审核延期申请',
    autoApprovedTooltip: '如果提交后3个工作日内未采取行动，请求将自动获得批准。',
    overdueTooltip: "此请求已逾期30天。 延迟反馈可能会影响达人的日程安排，并增加达人取消合作的风险。 ",
    overdueTooltipLink: "请联系我们获取帮助。",
    overdue: "需要处理",
  },

  yourCampaignCard: {
    reviewCollaboration: '审批达人申请',
    reviewDelivery: '审核交付',
    reviewFinalPost: '审核最终链接',
    enterShippingInformation: '填写发货信息',
    continueCampaign: '继续这个营销计划',
    reviewRequest: '审核请求',
    confirmInviteList: '审核邀请列表',
    influencersReadyToBeInvited: '{count} 位达人准备就绪，等待邀请',
    influencerAccessSetup: '开通达人权限',
    reviewRates: '审核报价',
    reviewLatestInfluencerRate: '审核最新达人报价',
    readyToPay: '确认报价',
    confirmRateAndPay: '确认报价并支付',
    selectFromAhaPicks: '审核达人',
  },

  adsOperateLab: {
    confirmCollaboration: '确认合作',
    approveDelivery: '通过交付',
    completeCollaboration: '完成合作',
    shipProduct: '寄送产品',
    influencerAccessSetup: '开通达人权限',
    selectFromAhaPicks: '从 Aha Picks 中选择',
  },

  timePassedComponent: {
    hasWaited: '已等待',
    forConfirmation: '',
    withdrawWarning:
      '等待超过 5 个工作日后，达人可能会撤回申请。'
  },
  checkDepositModal: {
    title: '充值余额',
    desc: '款项由第三方托管，并在达人交付完成后释放。如需充值详情，请参考',
    guide: '充值与活动预算指南',
    items: {
      payForResultsTitle: '只为结果买单',
      payForResultsDesc: '未按约定交付，支持 100% 原路退款',
      dualSidedContractTitle: '双向合同保障',
      dualSidedContractDesc: '每一次合作都由正式合同约束与保护',
      verifiedTrafficTitle: '真实有效的流量',
      verifiedTrafficDesc: '曝光与互动均经核验，拒绝虚假数据'
    },
    caseStudy: '成功案例',
    extraRights: '全球领先 AI 原生团队信赖之选',
    rights: {
      repurpose: '你拥有达人内容的再创作、剪辑与复用权',
      runAds: '可使用达人内容投放广告，商用无忧'
    },
    actions: {
      watchDemo: '看看效果',
      contactSales: '联系顾问',
      depositNow: '立即充值'
    },
    howFundsFlow: {
      title: '资金流程',
      description: '每个步骤都由平台保障，保护品牌和达人的权益。',
      steps: {
        deposit: '充值',
        launchCampaign: '启动活动',
        matchInfluencers: '匹配达人',
        confirmApplication: '确认达人申请',
        fundsLocked: '（资金锁定在托管账户）',
        delivery: '交付',
        fundsReleased: '资金释放'
      }
    },
    depositNow: '立即充值',
    depositItems: {
      budgetStoredTitle: '预算存储在您的钱包中',
      budgetStoredDesc: '您的预算安全存储在您的品牌钱包中，用于确认活动意图，只有在达人交付后才会使用。',
      lockReleaseTitle: '锁定和释放规则',
      lockReleaseDesc: '资金只有在达人确认后才会被锁定，并在交付完成后10天释放。',
      flexibleRefundsTitle: '灵活退款',
      flexibleRefundsDesc: '任何未使用的资金都可以随时退款——100%保证。',
      flexibleRefundsLink: '查看退款政策',
      transparentPricingTitle: '透明定价',
      transparentPricingDesc: '无订阅费，无隐藏费用——您只需为确认并交付的达人内容付费。',
      escrowProtectionTitle: '第三方托管保护',
      escrowProtectionDesc: '资金在交付前安全地由第三方托管，确保双方都得到充分保护。'
    }
  },
  modalRejectPostpone: {
    reject: "拒绝",
    letTheInfluenterKnowRejectReason: "让达人了解拒绝原因（可选）",
    rejectReason: "拒绝原因",
    rejectSuccess: "您已成功拒绝时间线延期！达人将收到时间线更新的通知。",
    rejectFailed: "发生错误！"
  },
  TipPostponePending: {
    viewRequest: "查看请求",
    timelineExtension: "达人已请求时间线延期",
    pleaseReviewAndProvideFeedback: "请仔细审核并提供反馈。"
  },
  rateModal: {
    title: "评分达人",
    description: "你的反馈将公开可见，直接影响达人的整体评分，请公平客观。注意所有评论都需要在发布前进行审核。",
    budgetConsumed: "预算消耗",
    cancel: "取消",
    submitRating: "提交评分",
    rating: "评分",
    review: "评论",
    pleaseSelectRating: "请选择评分"
  },
  reviews: {
    basedOnOnly: "基于在 AhaCreator 上的 {count} 次合作数据。这些统计反映了小样本量，可能不代表典型表现。仅作为参考。",
    completedCollaborations: "已完成合作",
    averageDeliveryDays: "平均交付天数",
    medianEngagementRate: "完单率",
    brandReviews: "品牌评论",
    deleteRateDes: '确认要删除这条评论吗？此操作无法撤销。',
    deleteRateTitle: '删除评论',
    noReviews: '暂无评论',
    noReviewsDesc: '暂无可展示的评论。',
    overdueHistory: '逾期历史',
    overdueSteps: '逾期步骤',
    missedDeadlines: "{count} 次逾期",
    specifiedTime: '预期提交时间',
    actualDeliveryTime: '实际交付时间',
    kickoffProduction: '启动制作',
    submitAddress: '提交收件地址',
    script: '提交想法/脚本',
    draft1: '提交内容草稿 1',
    draft2: '提交内容草稿 2',
    draft3: '提交内容草稿 3',
    draft4: '提交内容草稿 4',
    draft5: '提交内容草稿 5',
    finalLink: '提交最终链接',
    notYetDelivered: '尚未交付',
  },
  modalFeedbackUpdated: {
    edited: "已编辑",
    editedOn: "已编辑于 {date}",
    viewChanges: "查看变化",
    feedbackUpdated: "反馈更新",
    yourFeedback: "你的反馈",
    ok: "好的",
  },
  // InvitesSendingModeForm 组件
  invitesSendingModeForm: {
    title: '邀请发送模式',
    description: '选择 AhaCreator 是自动发送邀请还是等待你审核',
    autoSend: {
      label: '自动发送邀请（推荐）',
      desc: 'AhaCreator 在匹配到达人后立即发送邀请，以最快速度触达。'
    },
    reviewBeforeSending: {
      label: '审核后发送',
      desc: '在发送任何邀请前，你需要先审核达人列表。'
    }
  },
  influencerUpgradeForm: {
    title: "达人权限与信用",
    description: "如果达人需要账号访问或信用来尝试你的产品并创建内容，请启用此功能",
    enableAccessAddCredits: "启用额外权限 / 添加信用",
    noAccessNeeded: "无需额外权限",
    validationMessage: "请选择达人权限与信用",
    informationRequiredLabel: "需要达人提供的信息",
    instructionLabel: "达人操作说明",
    informationRequiredValidation: "请输入需要达人提供的信息",
    informationRequiredPlaceholder: "例如：邮箱、UID、社交媒体账号",
    instructionPlaceholder: "请提供您的登录邮箱或 UID（可在个人资料 → 账户信息中找到）",
    photos: "参考图片",
  },
  confirmAccessSetupButton: {
    buttonText: "确认账号信息",
  }
};
